var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandHeartOutlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.523438,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#EAEAEA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_246_11309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2234 16.6998V18.3998H19.7734V20.9498H21.4734V18.3998H24.0234V16.6998H21.4734V14.1498H19.7734V16.6998H17.2234ZM17.1979 13.8183C17.0959 12.6878 16.0249 11.5743 14.6734 11.5998C13.2284 11.6253 12.1234 12.7048 12.1234 14.1498C12.1234 15.5948 13.2284 16.6488 14.6734 16.6998C14.9964 16.6998 15.3279 16.6318 15.6424 16.5043C15.8719 15.5693 16.2544 14.6853 17.1979 13.8183ZM15.5234 17.5498H10.4234C10.4234 16.6148 9.66694 15.8498 8.72344 15.8498V12.4498C9.66694 12.4498 10.4234 11.6933 10.4234 10.7498H18.9234C18.9234 11.6933 19.6884 12.4498 20.6234 12.4498V12.5008C21.1929 12.5008 21.7624 12.6028 22.3234 12.7898V9.0498H7.02344V19.2498H15.7954C15.6084 18.6803 15.5234 18.1108 15.5234 17.5498Z",
    fill: "#414042"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_246_11309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(6.52344 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandHeartOutlineIcon);
export default __webpack_public_path__ + "static/media/hand-heart-outline-icon.a7179ae046463f23545b4f040db296dc.svg";
export { ForwardRef as ReactComponent };